export const SUPER_ADMIN = 'ROLE_SUPER_ADMIN';
export const ADMIN = 'ROLE_ADMIN';
export const CROQUI = 'ROLE_CROQUI';
export const INSPETOR = 'ROLE_INSPETOR';
export const DIGITADOR = 'ROLE_DIGITADOR';
export const AUDITORIA_NSIR = 'ROLE_AUDITORIA_NSIR';